<template>
  <div class="checkManage">
    <OATable
      ref="checkManage"
      :data="data"
      :columns="columns"
      :filterData="filterData"
      :selectionRow="true"
      :loading="loading"
      @search="handleSearch"
      @selectionChange="selectionChange"
    >
      <OAButton slot="button" @click="setRecord" :disabled="!checkList.length">记录设置</OAButton>
      <OAButton slot="button" @click="clockRules" class="pull-right">打卡规则设置</OAButton>
    </OATable>
    <OAModalForm
      title="设置"
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      @on-cancel="dialogVisible = false"
    ></OAModalForm>
  </div>
</template>
<script>
import checkApi from "@/services/check.js";
import OAModalForm from "@/components/OAModalForm/OAModalForm";
import OAHandle from "@/components/OAHandle/OAHandle";
import { resFilter } from "@/common/util.js";
import { jump } from "@/common/jump";
import { isTrue } from "@/common/dictionary.js";

export default {
  name: "checkManage",
  components: { OAModalForm, OAHandle },
  data() {
    let that = this;
    return {
      filterData: {
        companyId: {
          formType: "a-select",
          value: undefined,
          placeholder: "所属公司",
          col: 4,
          api: "getCompany",
          props: {
            label: "companyName",
            value: "id"
          },
          options: []
        },
        departIds: {
          formType: "a-depart-cascader",
          value: undefined,
          placeholder: "所在部门",
          col: 4,
          options: []
        },
        includeChild: {
          formType: "a-select",
          value: undefined,
          col: 4,
          placeholder: "是否包含子集",
          options: isTrue
        },
        employeeId: {
          formType: "a-auto-search",
          value: undefined,
          apiType: "getAll",
          col: 4,
          placeholder: "姓名工号"
        },
        toworkStatus: {
          formType: "a-select",
          value: undefined,
          placeholder: "上午考勤状态",
          code: 141,
          col: 4,
          options: []
        },
        offdutyStatus: {
          formType: "a-select",
          value: undefined,
          placeholder: "下午考勤状态",
          code: 141,
          col: 4,
          options: []
        },
        modifiedLog: {
          formType: "a-select",
          value: undefined,
          placeholder: "修正记录",
          col: 4,
          options: [
            {
              code: 0,
              name: "初始状态"
            },
            {
              code: 1,
              name: "已修正"
            }
          ]
        },
        attendanceDate: {
          formType: "a-date-picker",
          type: "daterange",
          value: undefined,
          startPlaceholder: "开始时间",
          endPlaceholder: "结束时间",
          col: 4
        }
      },
      columns: [
        {
          title: "公司",
          key: "companyName",
          minWidth: 200,
          showOverflowTooltip: true
        },
        {
          title: "工号",
          key: "employeeNumber"
        },
        {
          title: "姓名",
          minWidth: 100,
          showOverflowTooltip: true,
          key: "employeeName"
        },
        {
          title: "部门",
          key: "departName",
          minWidth: 150,
          showOverflowTooltip: true
        },
        {
          title: "日期",
          key: "attendanceDate",
          sortable: "custom",
          minWidth: 100
        },
        {
          title: "上班打卡时间",
          key: "timeTowork"
        },
        {
          title: "考勤状态",
          key: "toworkStatusName"
        },
        {
          title: "下班打卡时间",
          key: "timeOffduty"
        },
        {
          title: "考勤状态",
          key: "offdutyStatusName"
        },
        {
          title: "修正记录",
          key: "modifiedLogName"
        },
        {
          title: "操作",
          key: "",
          minWidth: 110,
          component: {
            name: OAHandle,
            props: {
              text: "查看打卡记录",
              onClick: function(val) {
                that.viewRecord(val.row.id);
              }
            }
          }
        }
      ],
      data: [],
      checkList: [],
      dialogVisible: false,
      loading: false,
      formData: {
        toworkStatus: {
          formType: "a-select",
          label: "上午考勤状态：",
          placeholder: "请选择",
          code: 141,
          value: "",
          options: []
        },
        toworkLeaveType: {
          formType: "a-select",
          label: "请假类型：",
          placeholder: "请选择",
          code: 142,
          displayWith: (formData, item) => {
            return formData.toworkStatus.value === 141003;
          },
          value: "",
          options: []
        },
        offdutyStatus: {
          formType: "a-select",
          label: "下午考勤状态：",
          placeholder: "请选择",
          code: 141,
          value: "",
          options: []
        },
        offdutyLeaveType: {
          formType: "a-select",
          label: "请假类型：",
          placeholder: "请选择",
          code: 142,
          displayWith: (formData, item) => {
            return formData.offdutyStatus.value === 141003;
          },
          value: "",
          options: []
        },
        remarks: {
          formType: "a-textarea",
          label: "备注：",
          placeholder: "请输入备注",
          value: ""
        }
      }
    };
  },
  mounted() {},
  methods: {
    async handleSearch(val) {
      this.loading = true;
      if (!val.sortType || !val.sortName) {
        val["sortName"] = "attendanceDate";
        val["sortType"] = "descending";
      }
      this.param = val;
      let res = await checkApi.getCheckManage(val);
      this.data = res.data.data;
      this.loading = false;
    },
    selectionChange(selection) {
      this.checkList = selection;
    },
    async viewRecord(id) {
      let res = await checkApi.getTime({ id: id });
      let data = res.data.data;
      let message = "";
      if (data.length) {
        data.map(item => {
          message += item.distinguishBetween + "：" + item.clockTime + "<br/>";
        });
      } else {
        message = "暂无数据";
      }
      this.$msgbox({
        message: message,
        center: true,
        showConfirmButton: false,
        callback: action => {},
        dangerouslyUseHTMLString: true,
        customClass: "messageCheck"
      });
    },
    setRecord() {
      this.dialogVisible = true;
    },
    async submit(val) {
      let ids = _.map(this.checkList, item => {
        return item.id;
      });
      let param = {
        id: ids,
        ...val
      };
      let res = await checkApi.setCheckRecord(param);
      resFilter(res, this.handleSearch(this.param));
      this.dialogVisible = false;
    },
    clockRules() {
      jump({
        url: "clockRules"
      });
    }
  }
};
</script>
<style lang="scss">
.messageCheck {
  padding-bottom: 0px;
  width: auto;
  p {
    font-size: 18px;
    line-height: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personnel/checkManage.vue